import { FormEvent, useState } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { useAuth } from '../../auth/AuthContext'

const Login = () => {
   const { signInWithPassword, isAuthenticated } = useAuth()
   const navigate = useNavigate()
   const location = useLocation() as any
   const [email, setEmail] = useState('')
   const [password, setPassword] = useState('')
   const [error, setError] = useState<string | null>(null)
   const [loading, setLoading] = useState(false)

   if (isAuthenticated) {
      navigate((location.state && location.state.from) || '/menu-admin', { replace: true })
   }

   const onSubmit = async (e: FormEvent) => {
      e.preventDefault()
      setError(null)
      setLoading(true)
      const res = await signInWithPassword(email, password)
      setLoading(false)
      if (res.error) {
         setError(res.error)
         return
      }
      navigate((location.state && location.state.from) || '/menu-admin', { replace: true })
   }

   return (
      <div className="flex min-h-screen items-center justify-center bg-[#f9f9f9] p-6">
         <form onSubmit={onSubmit} className="w-full max-w-sm rounded-lg bg-white p-6 shadow">
            <h1 className="mb-4 text-xl font-semibold">Yönetici Girişi</h1>
            <label className="mb-2 block text-sm">E-posta</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="mb-4 w-full rounded border px-3 py-2" required />
            <label className="mb-2 block text-sm">Şifre</label>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="mb-4 w-full rounded border px-3 py-2" required />
            {error && <div className="mb-3 text-sm text-red-600">{error}</div>}
            <button disabled={loading} type="submit" className="w-full rounded bg-black px-4 py-2 text-white disabled:opacity-60">
               {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
            <div className="mt-3 text-center text-xs text-gray-500">
               <Link to="/">Ana sayfaya dön</Link>
            </div>
         </form>
      </div>
   )
}

export default Login


